import { useState, useEffect } from "react";
import '../styles/catalogo.css';
import productos from "../data/productos";
import ProductoCard from '../components/productcard';

function Catalogo() {
  const [selectedFilter, setSelectedFilter] = useState("*");
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 600);
  const [showScrollTop, setShowScrollTop] = useState(false);

  const buttons = [
    { label: "Todo", filter: "*" },
    { label: "Artículos de temporada", filter: ".cat-1" },
    { label: "Ángeles", filter: ".cat-2" },
    { label: "Animales y decoración", filter: ".cat-3" },
    { label: "Cristos", filter: ".cat-4" },
    { label: "Cuadros", filter: ".cat-5" },
    { label: "Nacimientos", filter: ".cat-6" },
    { label: "Pastores", filter: ".cat-7" },
    { label: "Santos", filter: ".cat-8" },
    { label: "Niños Dios", filter: ".cat-9" },
  ];

  const productosFiltrados =
    selectedFilter === "*"
      ? productos
      : productos.filter((prod) => `.${prod.categoria}` === selectedFilter);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 600);
    window.addEventListener("resize", handleResize);

    const handleScroll = () => {
      setShowScrollTop(window.scrollY > 300);
    };
    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("resize", handleResize);
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  return (
    <div>
      <div className="mensaje-filtro">
        <h2>
          Aquí encontrarás todos las artesanías, figuras y artículos de temporada que tenemos para ti.
        </h2>
        <p>No se incluyen precios. Da click en la imagen para ampliarla.</p>
      </div>

      <div className="ui-group">
        {isMobile ? (
          
          <select
            className="filters-dropdown"
            value={selectedFilter}
            onChange={(e) => setSelectedFilter(e.target.value)}
          >
            {buttons.map((btn) => (
              <option key={btn.filter} value={btn.filter}>
                {btn.label} 
              </option>
            ))}
          </select>
        ) : (
          <div className="filters button-group js-radio-button-group device-type">
            {buttons.map((btn) => (
              <button
                key={btn.filter}
                className={`button ${selectedFilter === btn.filter ? "is-checked" : ""}`}
                data-filter={btn.filter}
                onClick={() => setSelectedFilter(btn.filter)}
              >
                {btn.label}
              </button>
            ))}
          </div>
        )}
      </div>

      <div className="productos-container">
        {productosFiltrados.map((producto) => (
          <ProductoCard key={producto.id} producto={producto} />
        ))}
      </div>

      {showScrollTop && (
        <button
          className="scroll-to-top"
          onClick={scrollToTop}
          aria-label="Volver al inicio"
          title="Volver al inicio"
        >
          ↑
        </button>
      )}
    </div>
  );
}

export default Catalogo;